import Close from "@/components/common/icons/close"
import Share from "@/components/common/social/share"
import { useRouter } from "next/router"
import { useEffect, useRef, useState } from "react"
import ReCAPTCHA from "react-google-recaptcha"
import { createShare } from "@/lib/api/share"
import { dialog } from "./dialog.module.css"
import SvgEkoIllusDunk3 from "./illustrations/pesticides-large"
import { calculate } from "./result"

export function Dialog({ people, food, modalRef, isOpen, setIsOpen }) {
  const router = useRouter()
  const recaptchaRef = useRef()
  const [shareUrl, setShareUrl] = useState("")
  const [pesticides, setPesticides] = useState(0)
  const siteKey = process.env.NEXT_PUBLIC_CAPTCHA_SITE_KEY

  useEffect(() => {
    const fetchShareURL = async () => {
      if (!isOpen) {
        return
      }

      const result = calculate(people, food)
      const token = await recaptchaRef.current.executeAsync()
      const response = await createShare(
        {
          id: "eko-effekten",
          people,
          food,
          calculations: [
            Math.floor(result[0].total),
            Math.floor(result[1].total),
            Math.floor(result[2].total)
          ]
        },
        router.asPath,
        token
      )

      if (!response.success) {
        console.log("error fetching hash url")
        return
      }

      setPesticides(Math.floor(result[0].total))
      setShareUrl(window.location.origin + response.path)
    }

    fetchShareURL()
  }, [people, food, router.asPath, isOpen])

  return (
    <>
      <ReCAPTCHA ref={recaptchaRef} size="invisible" sitekey={siteKey} />
      <dialog
        ref={modalRef}
        className={`${dialog} fixed inset-0 w-full sm:max-w-[535px] max-w-none p-0 mt-auto mb-0 mx-0 sm:m-auto rounded-t-sm overflow-visible`}
        onClick={({ target: dialog }) => {
          if (dialog.nodeName === "DIALOG") {
            modalRef.current.close()
            setIsOpen(false)
          }
        }}
        onClose={() => {
          setIsOpen(false)
        }}>
        <button
          aria-label="Stäng"
          onClick={() => modalRef.current.close()}
          type="button"
          className="absolute flex items-center justify-center w-8 h-8 rounded-full top-4 right-4 md:-top-4 md:-right-4 bg-black-100">
          <Close className="fill-white w-[12px] h-auto" />
        </button>
        <div className="p-8 sm:p-12">
          <SvgEkoIllusDunk3 className="mb-4" />
          <h4 className="mb-8">
            Dela din ekoeffekt. Få fler att upptäcka skillnaden med ekologiskt;
            naturen kommer att tacka dig!
          </h4>
          <Share
            wrapper="justify-between"
            classes="w-14 h-14 !bg-summer-green-100"
            iconSize="large"
            url={shareUrl}
            hidePrint="true"
            subject={`Ekoeffekten stoppade ${pesticides} liter bekämpningsmedel!`}
            bodyText="Så mycket bekämpningsmedel och konstgödsel stoppas genom ett byte till ekologiskt. Testa ekoeffekten du också! "
          />
        </div>
      </dialog>
    </>
  )
}
